/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { IAlert, IApiList } from '../../../types';
import { Alerts } from './types';

const initialState: IApiList<IAlert> | null = null;

export const alertsReducer: Reducer<IApiList<IAlert> | null> = (state = initialState, action) => {
  switch (action.type) {
    case Alerts.GET_USER_ALERTS_SUCCESS: {
      return action.payload;
    }
    default: {
      return state;
    }
  }
};
